import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-test", "data-item-grade"]
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "relative flex items-stretch gap-2.5 overflow-hidden" }

import { PropType, Ref, ref } from 'vue';
import { BlackDesertItem, BlackDesertItemType } from '@blackdesertmarket/interfaces';
import { VueAttributeClass } from '@/types/attributes-vue';
import { UseItemTypeReturn, useItemType } from '@/composables/item-type/use-item-type';
import { UseItemReturn, useItem } from '@/composables/item/use-item';
import { UseItemIconFetchReturn, useItemIconFetch } from '@/composables/item/use-item-icon-fetch';
import { TranslateKey, useInject } from '@/composables/use-inject';
import ListItemIcon from '@/components/ListItem/ListItemIcon.vue';
import ListItemName from '@/components/ListItem/ListItemName.vue';
import ListItemProperty from '@/components/ListItem/ListItemProperty.vue';
import ListItemSeparator from '@/components/ListItem/ListItemSeparator.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListItem',
  props: {
  item: {
    type: Object as PropType<BlackDesertItem>,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  class: {
    type: [String, Object] as PropType<VueAttributeClass>,
  },
},
  emits: {
  effect: null,
},
  setup(__props, { emit }) {

const props = __props;





const translate = useInject(TranslateKey);
const itemComposable: UseItemReturn = useItem(props.item);
const itemTypeComposable: UseItemTypeReturn = useItemType(props.item as BlackDesertItemType);
const itemIconFetch: UseItemIconFetchReturn = useItemIconFetch(props.item.id);

const itemGradeText: Ref<string> = ref('text-sm');
const itemGradeBorder: Ref<string> = ref('');
const itemIcon: Ref<string> = ref('');

const triggerListItemEffect = (): void => {
  emit('effect');
};

if (props.item.grade) {
  itemGradeText.value = `text-sm text:item-grade-${props.item.grade}`;
  itemGradeBorder.value = `border:item-grade-${props.item.grade}`;
}

if (!itemIcon.value) {
  itemIconFetch.fetch().then((icon: string): void => {
    itemIcon.value = icon;
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    "data-test": props.disabled ? 'list-item-disabled' : 'list-item',
    "data-item-grade": props.item.grade,
    class: _normalizeClass({
      [props.class]: true,
      'flex rounded bg-dark-400 shadow-md': true,
      'pointer-events-none': props.disabled,
    })
  }, [
    _createElementVNode("button", {
      disabled: props.disabled,
      class: "border-lighten hocus:bg-lighten-sm w-full cursor-pointer rounded border-t py-1.5 px-2 -outline-offset-1",
      onClick: triggerListItemEffect
    }, [
      _createElementVNode("span", _hoisted_3, [
        _renderSlot(_ctx.$slots, "icon", {}, () => [
          _createVNode(ListItemIcon, {
            src: itemIcon.value,
            item: props.item,
            text: _unref(itemTypeComposable).getItemIconText(),
            class: _normalizeClass(itemGradeBorder.value)
          }, null, 8, ["src", "item", "text", "class"])
        ]),
        _renderSlot(_ctx.$slots, "name", {}, () => [
          _createVNode(ListItemName, {
            name: _unref(itemTypeComposable).getItemName(),
            class: _normalizeClass(itemGradeText.value)
          }, null, 8, ["name", "class"])
        ]),
        _renderSlot(_ctx.$slots, "append", {}, () => [
          _createVNode(ListItemSeparator),
          _createVNode(ListItemProperty, {
            label: _unref(translate)('item.basePrice'),
            value: _unref(itemComposable).getBasePrice()
          }, null, 8, ["label", "value"]),
          _createVNode(ListItemSeparator),
          _createVNode(ListItemProperty, {
            label: _unref(translate)('item.count'),
            value: props.item.count
          }, null, 8, ["label", "value"])
        ])
      ])
    ], 8, _hoisted_2)
  ], 10, _hoisted_1))
}
}

})